export class ObjectFormService {
  static objFormToJSON(objFormData) {
    const paramJSON = {};
    objFormData.map(function (obj, ind) {
      if (obj.type === 'date') {
        paramJSON[obj.attrName] = `${obj.value}`;
      } else if (obj.type !== 'formula') {
        paramJSON[obj.attrName] = obj.value;
      }
      if (obj.allowMultiple === 'true') {
        paramJSON[`${obj.attrName}_multval`] = obj.multval;
      }
    });
    return paramJSON;
  }

  static getChangeOnlyFormData(objFormData, concatFieldName, newValue) {
    const targetField = this.findFieldByConcatName(
      objFormData,
      concatFieldName
    );

    if (!targetField) {
      console.warn(`Field ${concatFieldName} not found in form data`);
      return null;
    }

    const updatedField = this.updateFieldValue(targetField, newValue);
    // pourrait filter sur ce qui est utile
    return [updatedField];
  }

  static findFieldByConcatName(objFormData, concatFieldName) {
    return objFormData.find(
      (obj) => obj.key + obj.attrName === concatFieldName
    );
  }

  static updateFieldValue(field, newValue) {
    const isAllowMultiple = field.allowMultiple === 'true';
    return {
      ...field,
      value: isAllowMultiple ? newValue[0] : newValue[0],
      defaultValue: isAllowMultiple ? newValue[0] : newValue[0],
      ...(isAllowMultiple ? { multval: newValue } : {}),
    };
  }
}
